"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lowell = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const SelectCard_1 = require("../../inputs/SelectCard");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
class Lowell extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.LOWELL,
            cardType: CardType_1.CardType.LEADER,
            tags: [Tags_1.Tags.WILDCARD],
            metadata: {
                cardNumber: 'L12',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().megacredits(8).colon().text('CHANGE LEADER').asterix();
                    b.br.br;
                }),
                description: 'Once per game, pay 8 M€ to draw 3 Leader cards and choose one to play. Discard this card.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        return player.canAfford(8) && this.isDisabled === false;
    }
    action(player) {
        const cardsDrawn = [];
        const dealtLeaderCardsCount = Math.min(3, player.game.dealer.leaderDeck.length);
        for (let i = 0; i < dealtLeaderCardsCount; i++) {
            cardsDrawn.push(player.game.dealer.dealLeaderCard());
        }
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 8));
        this.isDisabled = true;
        if (cardsDrawn.length === 0)
            return undefined;
        return new SelectCard_1.SelectCard('Choose leader card to play', 'Play', cardsDrawn, (foundCards) => {
            const cardIndex = player.playedCards.findIndex((c) => c.name === this.name);
            player.playedCards.splice(cardIndex, 1);
            return player.playCard(foundCards[0]);
        });
    }
}
exports.Lowell = Lowell;
//# sourceMappingURL=Lowell.js.map